'use client';

import type { ReactNode } from 'react';
import { useIsNative } from '@/lib/native/use-is-native';

/** Digital subscription purchase/navigation surfaces are web-only. */
export function WebOnlyBillingAction({ children }: { children: ReactNode }) {
  const native = useIsNative();
  return (
    <span className="contents" data-web-billing-action="">
      {native ? null : children}
    </span>
  );
}
